export function makeid(length: number) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
 return result;
}

interface IColorRGB{
  readonly r: number;
  readonly g: number;
  readonly b: number;
  readonly hex: string;
}
interface IColorRGBA extends IColorRGB{
  readonly a: number;
}

interface IMakeColorProps{
  limitMin?: number;
  limitMax?: number;
}

export function makeRGB({limitMax=255, limitMin=0}:IMakeColorProps):IColorRGB {
  var o = Math.round, r = Math.random, s = limitMax-limitMin;
  const R=o(r()*s)+limitMin,G=o(r()*s)+limitMin,B=o(r()*s)+limitMin;

  return {
    r: R,
    g: G,
    b: B,
    hex: `#${R.toString(16)}${G.toString(16)}${B.toString(16)}`
  };
}

export function makeRGBA({limitMax=255, limitMin=0}:IMakeColorProps):IColorRGBA {
  var o = Math.round, r = Math.random, s = limitMax-limitMin;
  const R=o(r()*s)+limitMin,G=o(r()*s)+limitMin,B=o(r()*s)+limitMin,A=parseFloat(r().toFixed(1));

  return {
    r: R,
    g: G,
    b: B,
    a: A,
    hex: `#${R.toString(16)}${G.toString(16)}${B.toString(16)}${o(A*255).toString(16)}`
  };
}